<template>
  <el-col class="displayLayout" id="insuranceManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单状态">
          <el-select v-model="formInline.isInsuredStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="投保成功" value="1"></el-option>
            <el-option label="保单生效" value="7"></el-option>
            <el-option label="保单失效" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.accode" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">查询</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="orderIdNum"
                         width="210"
                         label="订单号">
        </el-table-column>
        <el-table-column prop="isInsuredStatusName"
                         label="保单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.isInsuredStatus === 1">投保成功</div>
            <div v-if="scope.row.isInsuredStatus === 7">保单生效</div>
            <div v-if="scope.row.isInsuredStatus === 9">保单失效</div>
          </template>
        </el-table-column>
        <el-table-column prop="insureAmount"
                         label="保险金额">
        </el-table-column>
        <el-table-column prop="payMoney"
                         label="保费">
        </el-table-column>
        <el-table-column prop="productName"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="policyHolderName"
                         min-width="150"
                         label="企业名称">
        </el-table-column>
        <el-table-column prop="months"
                         min-width="150"
                         label="保险期限">
        </el-table-column>
        <el-table-column prop="effectiveDate"
                         width="100"
                         label="开始生效时间">
        </el-table-column>
        <el-table-column prop="expireDate"
                         width="100"
                         label="结束生效时间">
        </el-table-column>
        <el-table-column label="其他操作">
          <template slot-scope="scope">
            <!--<el-button size="mini" v-if="scope.row.orderStatus === 0">编辑</el-button>
            <el-button size="mini" @click="onSubmit(scope.row)" v-if="scope.row.orderStatus === 0">提交</el-button>
            <el-button size="mini" @click="onSee(scope.row)">查看详情</el-button>
            <el-button size="mini" @click="onPay(scope.row)" v-if="scope.row.orderStatus === 4">错误消息</el-button>
            <el-button size="mini" @click="onDelete(scope.row)"
                       v-if=" scope.row.orderStatus === 0 || scope.row.orderStatus === 7 ">删除
            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getOrderList"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: "insuranceManagement",
    data() {
      return {
        loading: false,
        page: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        formInline: {
          accode: '',
          isInsuredStatus: '',
        }
      }
    },
    methods: {
      tariffInsuranceChitList() {
        this.loading = true;
        this.axios.post('/management/tariffInsurance/tariffInsuranceChitList', null, {
          params: {
            _pageSize: this.pageSize,
            _current: this.page,
            isInsuredStatus: this.formInline.isInsuredStatus,
            accode: this.formInline.accode,
          }
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            let {list, pagination} = data.datas;
            this.tableData = list;
            this.page = pagination.current;
            this.total = pagination.total;
            this.loading = false;

            list.forEach(item => {
              let {pdfUrl} = item;
              this.$$.isValidObj(pdfUrl) ? item.suffix = '投保单.' + pdfUrl.substr((~-pdfUrl.lastIndexOf(".") >>> 0) + 2) : item.pdfUrl = "javascript:;";
            });

          } else {
            this.$message.error(data.msg);
          }

          let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
          $('.el-table__body-wrapper').css('height', height);
        })
      },
      onSelect() {
        this.page = 1;
        this.tariffInsuranceChitList();
      },
    },
    mounted() {
      if (!this.$$.checkLogin()) return this.$$.confirmLogin(this);

      this.tariffInsuranceChitList();
    }
  }
</script>

<style scoped>
  @import "../../../../static/css/orderManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/product/dutyInsurance/insuranceManagement.vue